import { ClearStorageKeyProvide } from './clear-storage-key.interface';
import { CLEAR_STORAGE_KEYS_AFTER_LOGOUT } from './clear-storage-key.token';
import { Provider } from '@angular/core';

export function provideLogoutStorageCleanupKeys(keysOrFactory: ClearStorageKeyProvide | string[]): Provider {
  return {
    provide: CLEAR_STORAGE_KEYS_AFTER_LOGOUT,
    useFactory: () => (typeof keysOrFactory === 'function' ? keysOrFactory() : keysOrFactory),
  };
}
